import { render, staticRenderFns } from "./DrawerHandler.vue?vue&type=template&id=2b0c2ff0&scoped=true&"
import script from "./DrawerHandler.vue?vue&type=script&lang=js&"
export * from "./DrawerHandler.vue?vue&type=script&lang=js&"
import style0 from "./DrawerHandler.vue?vue&type=style&index=0&id=2b0c2ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c2ff0",
  null
  
)

export default component.exports